/**
 * App root component
 * Sets up routing and providers in correct order
 */
import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/query-client'
import { ThemeProvider } from '@/lib/theme/theme-provider'
import { TenantProvider } from '@/lib/tenant/tenant-provider'
import { LanguageProvider } from '@/contexts/LanguageContext'
import { JobDetailPage } from '@/pages/JobDetailPage'
import { DEFAULT_JOB_ID } from '@/data/static-jobs'
import BuildVersionWatermark from '@/components/BuildVersionWatermark'

export const App: React.FC = () => {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <LanguageProvider>
          <TenantProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/jobs/:jobId" element={<JobDetailPage />} />
                <Route path="/" element={<Navigate to={`/jobs/${DEFAULT_JOB_ID}`} replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
            <BuildVersionWatermark />
          </TenantProvider>
        </LanguageProvider>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
